module.exports = __webpack_public_path__ + "static/alice-b443fa41caa9098745594cc9172c8363.jpg";